import { inject, Injectable } from '@angular/core';
import { RefDimension } from '../models/ref-dimension.model';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { mapAsBody } from '../app/shared/util/request-util';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RefDimensionExtendedService  {

  readonly #apiProvider = inject(ApiProviderService);
  private endPoint = API_ENDPOINTS.REF_DIMENSION;

  public query(): Observable<RefDimension[]> {
    return this.#apiProvider.publicGet<RefDimension[]>(`${this.endPoint}`, { observe: 'response' })
      .pipe(mapAsBody)
      .pipe(map(val => (val || []).map(v => new RefDimension(v))))
  }
}
